import firebase from "firebase/compat/app";
import {db} from "../firebase";
import {getUid} from "./auth";
import {Collections} from "./collections";

export const addFollow = async (rmId) => {
    const uid = getUid();
    if (!uid || !rmId) return Promise.reject("Bad params");

    return db.collection(Collections.USERS).doc(uid).update(`follows.${rmId}`, {
        created: firebase.firestore.FieldValue.serverTimestamp(),
        rmId
    })
};

export const deleteFollow = async (rmId, companyId, blacklist) => {
    const uid = getUid();
    if (!uid || !companyId) return Promise.reject("Bad params");

    await db.collection(Collections.USERS).doc(uid).update(`follows.${rmId}`, firebase.firestore.FieldValue.delete());
    await db.collection(Collections.COMPANY_BLACKLISTS).doc(companyId).set({
        id: companyId,
        blacklist: blacklist ? firebase.firestore.FieldValue.arrayUnion(uid) : firebase.firestore.FieldValue.arrayRemove(uid)
    }, {merge: true});

    return Promise.resolve();
};